<template>
  <div class="min-h-screen bg-gray-50">
    <!-- pt-0: o espaço abaixo da Navbar fixa vem do Home (pt-16); evita “dobrar” padding com PropertyShowcase -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 pt-0">
      <!-- Property Showcase for Tenant -->
      <PropertyShowcase :tenantMode="true" :showHeader="true" />
    </div>
  </div>
</template>

<script>
import PropertyShowcase from './PropertyShowcase.vue'

export default {
  components: {
    PropertyShowcase
  }
}
</script>
